import * as models from "@common/models/v2";
import type * as schemas from "@common/schemas/v2";
import { BaseStep } from "./base";
import { StepActions } from "./step";
import { makeObservable, observable, override } from "mobx";
import { FlowFlexibility } from "@common/schemas";

export class UserInputStep extends BaseStep {
  attributes: models.UserInputStepAttributes;
  actions: StepActions;

  target?: Element | null;
  isConfirmed: boolean = false;
  stopTrackingTargetElement?: () => void;

  constructor(step: schemas.Step, actions: StepActions, flowFlexibility: FlowFlexibility) {
    super(step, actions, flowFlexibility);

    this.attributes = new models.UserInputStepAttributes(step.attributes as schemas.UserInputStepAttributes);
    this.actions = actions;
    makeObservable(this, {
      isConfirmed: observable,
      isBlocking: override,
    });
  }

  async run() {
    super.run();
    this.isConfirmed = false;
    this.trackTargetElement();
  }

  private trackTargetElement() {
    this.stopTrackingTargetElement?.();
    this.stopTrackingTargetElement = this.actions.onTargetElementChange(
      this.id,
      this.handleTargetElementChange.bind(this)
    );
  }

  private handleTargetElementChange(targetElement: Element | null) {
    this.target = targetElement;
    this.actions.setCurrentTargetElement(targetElement);
  }

  dispose() {
    super.dispose();
    this.stopTrackingTargetElement?.();
    this.stopTrackingTargetElement = undefined;
    this.target = undefined;
    this.actions.setCurrentTargetElement(undefined);
  }

  handleProceed() {
    this.isConfirmed = true;
  }

  get isBlocking() {
    return !this.isConfirmed;
  }

  get isBlockingStepType() {
    return true;
  }

  get isTargetableStepType() {
    return true;
  }
}
